// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.PaymentContent-container-MzLgP {
	width: 100%;
	max-width: var(--max-container-width);
	margin: 0 auto;
	padding: 0 15px;
}
.PaymentContent-flex-G5wXb {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-top: 35px;
}
.PaymentContent-name-ikeSb {
	font-size: 18px;
	font-weight: 600;
	padding-left: 18px;
}
.PaymentContent-content-MnMxR {
	font-size: 16px;
	color: var(--secondary-foreground);
	margin-top: 23px;
	font-style: italic;
}
.PaymentContent-imgCss-ZOblT {
	width: 48px;
	height: 48px;
	border-radius: 50%;
}
.PaymentContent-outline-cwOQR {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	padding: 42px 30px;
}
.PaymentContent-iconCss-axtJW {
	width: 51px;
	height: 39px;
}
.PaymentContent-mainhedding-S4sMx h1 {
	font-size: 46px;
	text-align: center;
	margin: 0 0 60px;
	font-weight: 600;
	color: var(--primary-foreground);
}
.PaymentContent-displayInline-uWDEM {
	display: inline-block;
	cursor: pointer;
}
.PaymentContent-arrowCenter-zF2ZX {
	position: relative;
	text-align: center;
	margin-top: 38px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	gap: 24px;
}
@media screen and (max-width: 991px) {
	.PaymentContent-mainhedding-S4sMx h1 {
		font-size: 36px;
	}
}
@media screen and (max-width: 767px) {
	.PaymentContent-mainhedding-S4sMx h1 {
		font-size: 24px;
		text-align: left;
		margin: 0 0 45px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/WhyHost/PaymentContent/PaymentContent.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;CACC,WAAW;CACX,qCAAqC;CACrC,cAAc;CACd,eAAe;AAChB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,YAAY;AACb;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,gCAAgC;AACjC;AAEA;CACC,qBAAqB;CACrB,eAAe;AAChB;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,SAAS;AACV;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC;EACC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;CACjB;AACD","sourcesContent":["/** RentAll - Begin **/\n.container {\n\twidth: 100%;\n\tmax-width: var(--max-container-width);\n\tmargin: 0 auto;\n\tpadding: 0 15px;\n}\n\n.flex {\n\tdisplay: flex;\n\talign-items: center;\n\tmargin-top: 35px;\n}\n\n.name {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tpadding-left: 18px;\n}\n\n.content {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tmargin-top: 23px;\n\tfont-style: italic;\n}\n\n.imgCss {\n\twidth: 48px;\n\theight: 48px;\n\tborder-radius: 50%;\n}\n\n.outline {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tpadding: 42px 30px;\n}\n\n.iconCss {\n\twidth: 51px;\n\theight: 39px;\n}\n\n.mainhedding h1 {\n\tfont-size: 46px;\n\ttext-align: center;\n\tmargin: 0 0 60px;\n\tfont-weight: 600;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n\tcursor: pointer;\n}\n\n.arrowCenter {\n\tposition: relative;\n\ttext-align: center;\n\tmargin-top: 38px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 24px;\n}\n\n@media screen and (max-width: 991px) {\n\t.mainhedding h1 {\n\t\tfont-size: 36px;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.mainhedding h1 {\n\t\tfont-size: 24px;\n\t\ttext-align: left;\n\t\tmargin: 0 0 45px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PaymentContent-container-MzLgP`,
	"flex": `PaymentContent-flex-G5wXb`,
	"name": `PaymentContent-name-ikeSb`,
	"content": `PaymentContent-content-MnMxR`,
	"imgCss": `PaymentContent-imgCss-ZOblT`,
	"outline": `PaymentContent-outline-cwOQR`,
	"iconCss": `PaymentContent-iconCss-axtJW`,
	"mainhedding": `PaymentContent-mainhedding-S4sMx`,
	"displayInline": `PaymentContent-displayInline-uWDEM`,
	"arrowCenter": `PaymentContent-arrowCenter-zF2ZX`
};
module.exports = ___CSS_LOADER_EXPORT___;
